import { ComponentChildren } from "preact";
import { Section } from "./Section.tsx";

export function CenteredContent(props: {
  children: ComponentChildren;
  imageSrc: string;
  imageAlt: string;
}) {
  return (
    <Section>
      <div style="text-align: center; max-width: 800px; margin: 0 auto;">
        {props.children}
        <img
          src={props.imageSrc}
          alt={props.imageAlt}
          style="width: 100%; max-width: 600px; border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.1); margin-bottom: 2rem;"
        />
      </div>
    </Section>
  );
}